import { jsx as _jsx } from "react/jsx-runtime";
import { useShortIdContext } from "@air/provider-short-id";
import { memo } from "react";
import { AudioSampleRatesSelect } from "~/components/Filters/AudioSampleRateFilter/components/AudioSampleRatesSelect";
import { usePublicAudioSampleRatesList } from "~/swr-hooks/filters/usePublicAudioSampleRatesList";
export const PublicAudioSampleRatesSelect = /*#__PURE__*/ memo((param)=>{
    let { boardId, ...props } = param;
    const { shortId } = useShortIdContext();
    const { data = [], isLoading } = usePublicAudioSampleRatesList({
        shortId,
        boardId
    });
    return /*#__PURE__*/ _jsx(AudioSampleRatesSelect, {
        isLoading: isLoading,
        audioRates: data,
        ...props
    });
});
PublicAudioSampleRatesSelect.displayName = "PublicAudioSampleRatesSelect";
